import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorTeamProfile extends InternalStaticAnchor {
	/**
	 * @type {string}
	 * @private
	 */
	_pattern = '/team/members';
}
